export class IdViewModel {
    ids:number[];
    cols:string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/view-model/id.viewModel.ts